import { FC, useEffect, useMemo } from 'react'
import { Box, Input, Select } from '@chakra-ui/react'
import { UseFormRegister } from 'react-hook-form'

import { FormItem } from 'components'
import { JOBSITE_INITIAL_FILTER_FIELDS } from 'InstitutionalManagement/constants/pages/jobsites'
import { JobsiteFieldsName, JobsiteFilterKeyString } from 'InstitutionalManagement/types'
import { STATUS_OPTIONS } from 'constants/variables'
import { focusElementById } from 'utils/events'

type Props = {
  hasPrefix?: boolean
  isOpen?: boolean
  register: UseFormRegister<JobsiteFilterKeyString>
  onlyFields?: JobsiteFieldsName[]
}

const JobsiteFilterForm: FC<Props> = ({ hasPrefix, isOpen = false, register, onlyFields }) => {
  const jobsiteFilterFields = useMemo(() => {
    return onlyFields || JOBSITE_INITIAL_FILTER_FIELDS
  }, [])

  function setPrefix(key: JobsiteFieldsName) {
    if (hasPrefix) return `jobsite_${key}`
    return key
  }

  useEffect(() => {
    focusElementById('name')
  }, [isOpen])

  return (
    <Box>
      {jobsiteFilterFields.includes('id') && (
        <FormItem label="ID" htmlFor="id">
          <Input id="id" {...register(setPrefix('id'))} />
        </FormItem>
      )}
      {jobsiteFilterFields.includes('name') && (
        <FormItem label="Nome" htmlFor="name">
          <Input id="name" {...register(setPrefix('name'))} />
        </FormItem>
      )}
      {jobsiteFilterFields.includes('description') && (
        <FormItem label="Descrição" htmlFor="description">
          <Input id="description" {...register(setPrefix('description'))} />
        </FormItem>
      )}
      {jobsiteFilterFields.includes('status') && (
        <FormItem label="Status" htmlFor="status">
          <Select id="status" {...register(setPrefix('status'))}>
            {STATUS_OPTIONS.map(({ label, value }) => {
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              )
            })}
          </Select>
        </FormItem>
      )}
    </Box>
  )
}

export default JobsiteFilterForm
